import AdminApplications from "../../components/Admin/AdminApplications";
import DashboardLayout from "../../components/Layout/DashboardLayout";
import { applicationStatusMap } from "../../config/applicationStatusConfig";

const SLACRejectedApplications = () => {
  return (
    <DashboardLayout pageTitle="Application" mainClass="p-6">
      <AdminApplications
        title="Rejected Applications(SLAC)"
        status={[applicationStatusMap?.rejected.value]}
        stage={[]}
      />
    </DashboardLayout>
  );
};

export default SLACRejectedApplications;
